import { SectionLabel, CtaButton, Reveal } from "./shared";

const TRANSFORMS = [
  "You'll be able to name the specific questions that decide your next move instead of guessing",
  "You'll understand how the pieces of a VA-backed purchase fit together as one transaction",
  "You'll leave with a clearer next step — prepare, apply, or review — chosen on purpose",
];

export default function Empathy() {
  return (
    <section className="py-24 lg:py-36 px-6 lg:px-10" data-testid="empathy-section">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14">
        <Reveal>
          <SectionLabel n="006" text="SOUND FAMILIAR?" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-8 leading-tight">
            If You're Like Most Buyers I Work With…
          </h2>
          <div className="space-y-5 text-white/60 text-[15px] leading-[1.8]">
            <p>
              You've probably collected two or three quotes that don't line up with each other, been told "not yet"
              without any explanation of what would change that answer, and retold the same story to a handful of
              different people who each asked for the same documents and gave back a different number.
            </p>
            <p>
              And if you already own a home, you may genuinely not know whether it helps your next purchase or
              complicates it — because nobody has walked you through how it fits into the whole picture. That's not a
              you problem. That's confusion and lost time created by a process that hands out numbers without
              context.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="border border-[#0162CA]/30 bg-[#0162CA]/[0.05] p-8 lg:p-10 h-full">
            <p className="font-mono-strict text-[11px] tracking-[0.28em] text-[#0162CA] mb-8">
              HERE'S WHAT CHANGES AFTER THIS MASTERCLASS:
            </p>
            <ul className="space-y-6">
              {TRANSFORMS.map((t, i) => (
                <li key={i} className="flex gap-4 text-white/80 text-[15px] leading-relaxed" data-testid={`transform-bullet-${i + 1}`}>
                  <span className="text-[#0162CA] font-bold shrink-0">→</span>
                  {t}
                </li>
              ))}
            </ul>
            <div className="mt-10">
              <CtaButton testId="empathy-cta" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
